import React, { Component } from 'react';
import jquery from 'jquery';
import { Table } from 'antd';
import '../style/home.less';

class MainContent extends Component {
    getRender = (text, record) => {
        const obj = {
            children: text,
            props: {},
        };
        if (record.rowSpan) {
            obj.props.rowSpan = record.rowSpan;
        } else {
            obj.props.rowSpan = 0;
        }
        if (record.colSpan) {
            obj.props.colSpan = record.colSpan;
        }
        if (text.startsWith('合计')) {
            obj.children = <strong>{text}</strong>;
        }
        if (record.minorItem == '-') {
            obj.children = `${text}（上限${record.maxScoreValue}分）`;
        }
        return obj;
    }

    getMainColumns = () => ([
        {
            title: '考核项',
            dataIndex: 'performanceScoreName',
            key: 'performanceScoreName',
            width: 380,
            render: this.getRender,
        }, {
            title: '细项',
            dataIndex: 'minorItem',
            key: 'minorItem',
            width: 380,
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: {},
                };
                if (!text) {
                    obj.props.colSpan = 0;
                } else if (text != '-') {
                    obj.children = `${text}（上限${record.maxScoreValue}分）`;
                }
                return obj;
            }
        }, {
            title: '得分',
            dataIndex: 'scoreValue',
            key: 'scoreValue',
            width: 370,
            render: (text, record) => {
                if (record.performanceScoreName.startsWith('合计')) {
                    return <strong>{text}</strong>;
                }
                return text;
            }
        }
    ])

    getMainDataSource = () => {
        const { performanceScores } = this.props;
        let key = 1;
        let dataSource = [];
        performanceScores.forEach(item => {
            if (item.childrens && item.childrens.length > 0) {
                item.childrens.forEach((childItem, childIndex) => {
                    dataSource.push({
                        key,
                        ...item,
                        rowSpan: !childIndex ? item.childrens.length : 0,
                        scoreValue: childItem.scoreValue,
                        maxScoreValue: childItem.maxScoreValue,
                        minorItem: childItem.performanceScoreName,
                        performanceScoreId: childItem.performanceScoreId,
                    });
                    key++;
                });
            } else {
                if (item.performanceScoreName.startsWith('合计')) {
                    dataSource.push({
                        key,
                        ...item,
                        rowSpan: 1,
                        colSpan: 2,
                    });
                } else {
                    dataSource.push({
                        key,
                        ...item,
                        rowSpan: 1,
                        minorItem: '-',
                    });
                }
                key++;
            }
        });
        return dataSource;
    }

    getTaskRender = (text, record) => {
        const obj = {
            children: (text || text === 0) ? text : '-',
            props: {},
        };
        const { investigationName } = record;
        if (investigationName == '任务测评合计') {
            obj.props.colSpan = 0;
        }
        return obj;
    }

    getTaskColumns = () => ([
        {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 200,
            fixed: 'left',
            render: (text, record) => {
                const obj = {
                    props: {},
                    children: text,
                };
                const { investigationName } = record;
                if (investigationName == '任务测评合计') {
                    obj.props.colSpan = 3;
                }
                return obj;
            }
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 140,
            fixed: 'left',
            render: this.getTaskRender,
        }, {
            title: '服务类型',
            dataIndex: 'requirementInfoType',
            key: 'requirementInfoType',
            width: 80,
            fixed: 'left',
            render: this.getTaskRender,
        }, {
            title: '立项',
            children: [
                {
                    title: '递交完成',
                    dataIndex: 'projectSubmitted',
                    key: 'projectSubmitted',
                    width: 70,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: (text || text === 0) ? text : '-',
                        };
                        const { projectValue, investigationName } = record;
                        if (investigationName == '任务测评合计') {
                            obj.props.colSpan = 3;
                            obj.children = <div style={{textAlign:'center'}}><strong>{projectValue}</strong></div>;
                        }
                        return obj;
                    }
                }, {
                    title: '立项通过',
                    dataIndex: 'projectPassed',
                    key: 'projectPassed',
                    width: 70,
                    render: this.getTaskRender,
                }, {
                    title: '该项得分',
                    dataIndex: 'projectValue',
                    key: 'projectValue',
                    width: 70,
                    render: this.getTaskRender,
                }
            ]
        }, {
            title: 'EC',
            children: [
                {
                    title: '递交完成',
                    dataIndex: 'ecSubmitted',
                    key: 'ecSubmitted',
                    width: 70,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: (text || text === 0) ? text : '-',
                        };
                        const { ecValue, investigationName } = record;
                        if (investigationName == '任务测评合计') {
                            obj.props.colSpan = 3;
                            obj.children = <div style={{textAlign:'center'}}><strong>{ecValue}</strong></div>;
                        }
                        return obj;
                    }
                }, {
                    title: 'EC通过',
                    dataIndex: 'ecPassed',
                    key: 'ecPassed',
                    width: 70,
                    render: this.getTaskRender,
                }, {
                    title: '该项得分',
                    dataIndex: 'ecValue',
                    key: 'ecValue',
                    width: 70,
                    render: this.getTaskRender,
                }
            ]
        }, {
            title: '研究主合同',
            children: [
                {
                    title: '递交site',
                    dataIndex: 'masterContractSubmittedSite',
                    key: 'masterContractSubmittedSite',
                    width: 70,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: (text || text === 0) ? text : '-',
                        };
                        const { masterContractValue, investigationName } = record;
                        if (investigationName == '任务测评合计') {
                            obj.props.colSpan = 3;
                            obj.children = <div style={{textAlign:'center'}}><strong>{masterContractValue}</strong></div>;
                        }
                        return obj;
                    }
                }, {
                    title: '签署完成',
                    dataIndex: 'masterContractSign',
                    key: 'masterContractSign',
                    width: 70,
                    render: this.getTaskRender,
                }, {
                    title: '该项得分',
                    dataIndex: 'masterContractValue',
                    key: 'masterContractValue',
                    width: 70,
                    render: this.getTaskRender,
                }
            ]
        }, {
            title: '遗传办',
            children: [
                {
                    title: '在线填报申请材料',
                    dataIndex: 'completionApplicationMaterialsOnline',
                    key: 'completionApplicationMaterialsOnline',
                    width: 70,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: (text || text === 0) ? text : '-',
                        };
                        const { heredityValue, investigationName } = record;
                        if (investigationName == '任务测评合计') {
                            obj.props.colSpan = 3;
                            obj.children = <div style={{textAlign:'center'}}><strong>{heredityValue}</strong></div>;
                        }
                        return obj;
                    }
                }, {
                    title: '获批',
                    dataIndex: 'heredityRepeatApprove',
                    key: 'heredityRepeatApprove',
                    width: 70,
                    render: this.getTaskRender,
                }, {
                    title: '该项得分',
                    dataIndex: 'heredityValue',
                    key: 'heredityValue',
                    width: 70,
                    render: this.getTaskRender,
                }
            ]
        }, {
            title: '启动会',
            children: [
                {
                    title: '启动会',
                    dataIndex: 'startMeet',
                    key: 'startMeet',
                    width: 70,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: (text || text === 0) ? text : '-',
                        };
                        const { meetValue, investigationName } = record;
                        if (investigationName == '任务测评合计') {
                            obj.props.colSpan = 2;
                            obj.children = <div style={{textAlign:'center'}}><strong>{meetValue}</strong></div>;
                        }
                        return obj;
                    }
                }, {
                    title: '该项得分',
                    dataIndex: 'meetValue',
                    key: 'meetValue',
                    width: 70,
                    render: this.getTaskRender,
                }
            ]
        }, {
            title: '任务测评总分',
            dataIndex: 'totalValue',
            key: 'totalValue',
            width: 90,
            render: (text, record, index) => {
                const { ssuPerformanceTask = [] } = this.props;
                const len = ssuPerformanceTask.length;
                const obj = {
                    children: (text || text === 0) ? text : '-',
                    props: {},
                };
                const { investigationName } = record;
                if (index == 0) {
                    obj.props.rowSpan = len - 1;
                } else if (index == len - 1) {
                    obj.props.rowSpan = 1;
                } else {
                    obj.props.rowSpan = 0;
                }
                if (investigationName == '任务测评合计') {
                    obj.children = <div style={{textAlign:'center'}}><strong>{text}</strong></div>;
                }
                return obj;
            }
        }
    ])

    getTaskDataSource = () => {
        const { ssuPerformanceTask = [] } = this.props;
        const dataSource = ssuPerformanceTask.map((item, index) => {
            return {
                index: index + 1,
                ...item,
            }
        });
        // 处理表头分组没数据时，不显示滚动条的bug
		if (!dataSource.length) {
			jquery('.ssuPerformanceDetail-task .ant-table-scroll .ant-table-header').css('margin-bottom', 0);
		} else {
			jquery('.ssuPerformanceDetail-task .ant-table-scroll .ant-table-header').css('margin-bottom', -16);
		}
        return dataSource;
    }

    getEfficiencyColumns = () => [{
        title: '任务测评总分',
        dataIndex: 'totalPoints',
        key: 'totalPoints',
        width: 200,
    }, {
        title: '项目启动前相关的FTE',
        dataIndex: 'ftePoints',
        key: 'ftePoints',
        width: 200,
    }, {
        title: '效率',
        dataIndex: 'efficientPoints',
        key: 'efficientPoints',
        width: 200,
    }, {
        title: '效率测评得分',
        dataIndex: 'trueEfficientEvaluationPoints',
        key: 'trueEfficientEvaluationPoints',
        width: 200,
    }]

    getEfficiencyDataSource = () => {
        const { ssuPerformanceEfficient } = this.props;
        const dataSource = [];
        if (ssuPerformanceEfficient) {
            dataSource.push({
                index: 1,
                ...ssuPerformanceEfficient,
            });
        }
        return dataSource;
    }

    getSpeedRender = (text, record) => {
        const obj = {
            children: (text || text === 0) ? text : '-',
            props: {},
        };
        const { investigationName } = record;
        if (investigationName == '平均日期(工作日)') {
            obj.props.colSpan = 0;
        }
        return obj;
    }

    getSpeedColumns = () => ([
        {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            render: (text, record) => {
                const obj = {
                    props: {},
                    children: text,
                };
                const { investigationName } = record;
                if (investigationName == '平均日期(工作日)') {
                    obj.props.colSpan = 3;
                    obj.children = <strong>{text}</strong>
                }
                return obj;
            }
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
            render: this.getSpeedRender,
        }, {
            title: '服务类型',
            dataIndex: 'requirementInfoType',
            key: 'requirementInfoType',
            width: 80,
            render: this.getSpeedRender,
        }, {
            title: '立项',
            children: [
                {
                    title: '立项递交日期',
                    dataIndex: 'projectSubmittedTime',
                    key: 'projectSubmittedTime',
                    width: 90,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: text ? text.slice(0, 10) : '-',
                        };
                        const { avgProject, investigationName } = record;
                        if (investigationName == '平均日期(工作日)') {
                            obj.props.colSpan = 3;
                            obj.children = (avgProject || avgProject === 0) ?
                                <div style={{textAlign:'center'}}><strong>{avgProject}</strong></div> : '-';
                        }
                        return obj;
                    }
                }, {
                    title: '立项通过日期',
                    dataIndex: 'projectPassedTime',
                    key: 'projectPassedTime',
                    width: 90,
                    render: (text, record) => {
                        const obj = {
                            children: text ? text.slice(0, 10) : '-',
                            props: {},
                        };
                        const { investigationName } = record;
                        if (investigationName == '平均日期(工作日)') {
                            obj.props.colSpan = 0;
                        }
                        return obj;
                    }
                }, {
                    title: '立项工期',
                    dataIndex: 'projectSubmittedToPassedDays',
                    key: 'projectSubmittedToPassedDays',
                    width: 70,
                    render: this.getSpeedRender,
                }
            ]
        }, {
            title: 'EC',
            children: [
                {
                    title: 'EC递交日期',
                    dataIndex: 'ecSubmittedTime',
                    key: 'ecSubmittedTime',
                    width: 90,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: text ? text.slice(0, 10) : '-',
                        };
                        const { avgEc, investigationName } = record;
                        if (investigationName == '平均日期(工作日)') {
                            obj.props.colSpan = 3;
                            obj.children = (avgEc || avgEc === 0) ?
                                <div style={{textAlign:'center'}}><strong>{avgEc}</strong></div> : '-';
                        }
                        return obj;
                    }
                }, {
                    title: 'EC批件日期',
                    dataIndex: 'ecPassedTime',
                    key: 'ecPassedTime',
                    width: 90,
                    render: (text, record) => {
                        const obj = {
                            children: text ? text.slice(0, 10) : '-',
                            props: {},
                        };
                        const { investigationName } = record;
                        if (investigationName == '平均日期(工作日)') {
                            obj.props.colSpan = 0;
                        }
                        return obj;
                    }
                }, {
                    title: 'EC工期',
                    dataIndex: 'ecSubmittedToApproveDays',
                    key: 'ecSubmittedToApproveDays',
                    width: 70,
                    render: this.getSpeedRender,
                }
            ]
        }, {
            title: '研究主合同',
            children: [
                {
                    title: '开始审核日期',
                    dataIndex: 'masterContractSubmittedSiteTime',
                    key: 'masterContractSubmittedSiteTime',
                    width: 90,
                    render: (text, record) => {
                        const obj = {
                            props: {},
                            children: text ? text.slice(0, 10) : '-',
                        };
                        const { avgMasterContract, investigationName } = record;
                        if (investigationName == '平均日期(工作日)') {
                            obj.props.colSpan = 3;
                            obj.children = (avgMasterContract || avgMasterContract === 0) ?
                                <div style={{textAlign:'center'}}><strong>{avgMasterContract}</strong></div> : '-';
                        }
                        return obj;
                    }
                }, {
                    title: '签署日期',
                    dataIndex: 'masterContractSignTime',
                    key: 'masterContractSignTime',
                    width: 90,
                    render: (text, record) => {
                        const obj = {
                            children: text ? text.slice(0, 10) : '-',
                            props: {},
                        };
                        const { investigationName } = record;
                        if (investigationName == '平均日期(工作日)') {
                            obj.props.colSpan = 0;
                        }
                        return obj;
                    }
                }, {
                    title: '研究主合同工期',
                    dataIndex: 'masterContractSubmittedSiteToSignDays',
                    key: 'masterContractSubmittedSiteToSignDays',
                    width: 90,
                    render: this.getSpeedRender,
                }
            ]
        }
    ])

    getSpeedDataSource = () => {
        const { ssuPerformanceSpeed = [] } = this.props;
        const dataSource = ssuPerformanceSpeed.map((item, index) => {
            return {
                index: index + 1,
                ...item,
            }
        });
        return dataSource;
    }

    render() {
        const { loading } = this.props;
        return (
            <div>
                <div style={{ lineHeight: '48px' }}>1.主要业绩分明细</div>
                <Table
                    bordered
                    loading={loading}
                    scroll={{x: 1130}}
                    pagination={false}
                    columns={this.getMainColumns()}
                    dataSource={this.getMainDataSource()}
                    rowKey={record => record.key}
                />
                <div style={{ lineHeight: '48px' }}>2.SSU人员任务测评明细</div>
                <Table
                    bordered
                    loading={loading}
                    scroll={{x: 1490, y: 300}}
                    pagination={false}
                    className="ssuPerformanceDetail-task"
                    style={{borderBottom: '1px solid #d1d1d1'}}
                    columns={this.getTaskColumns()}
                    dataSource={this.getTaskDataSource()}
                    rowKey={record => record.index}
                />
                <div style={{ lineHeight: '48px' }}>3.SSU人员效率测评明细</div>
                <Table
                    bordered
                    loading={loading}
                    scroll={{x: 800}}
                    pagination={false}
                    columns={this.getEfficiencyColumns()}
                    dataSource={this.getEfficiencyDataSource()}
                    rowKey={record => record.index}
                />
                <div style={{ lineHeight: '48px' }}>4.SSU人员速度测评明细</div>
                <Table
                    bordered
                    loading={loading}
                    scroll={{x: 1120, y: 300}}
                    pagination={false}
                    style={{borderBottom: '1px solid #d1d1d1'}}
                    columns={this.getSpeedColumns()}
                    dataSource={this.getSpeedDataSource()}
                    rowKey={record => record.index}
                />
            </div>
        )
    }
}

export default MainContent;


// WEBPACK FOOTER //
// ./src/components/home/ssuPerformanceDetail/MainContent.js